import React from 'react';
import './audiology.css';

import { Link } from 'react-router-dom';

import { FaAssistiveListeningSystems, FaUserMd, FaClinicMedical, FaChartLine, FaGraduationCap, FaCertificate } from 'react-icons/fa';

function AudiologyCourse() {
  return (
    <div className="audiology-page">
      {/* Hero Banner */}
      <section className="audiology-hero">
        <div className="audio-hero-overlay">
          <h1>Audiology Programs</h1>
          <p className="subtitle">Develop expertise in hearing health and balance disorders</p>
          <div className="program-badges">
          </div>
        </div>
      </section>

      {/* Program Options */}
      <section className="program-options">
        <div className="container">
          <h2 className="section-title">Choose Your Program Level</h2>
          <div className="program-cards">
            {/* Certificate Program */}
            <div className="program-card cert-card">
              <div className="program-header">
                <FaCertificate className="program-icon" />
                <h3>Certificate in Audiology</h3>
                <p className="program-duration">6 Months | Full-time</p>
              </div>
              <div className="program-body">
                <h4>Core Focus Areas:</h4>
                <ul>
                  <li>Fundamentals of Hearing Science</li>
                  <li>Basic Audiometric Testing</li>
                  <li>Hearing Aid Technology</li>
                  <li>Clinical Observation</li>
                </ul>
                <div className="program-details">
                  <p><strong>Entry Requirements:</strong> A/Ls with Science subjects</p>
                  <p><strong>Credits:</strong> 18</p>
                </div>
              </div>
              <button className="program-cta">Program Details</button>
            </div>

            {/* Diploma Program */}
            <div className="program-card diploma-card">
              <div className="program-header">
                <FaGraduationCap className="program-icon" />
                <h3>Diploma in Clinical Audiology</h3>
                <p className="program-duration">1 Year | Full-time</p>
                <div className="featured-badge">Career-Focused</div>
              </div>
              <div className="program-body">
                <h4>Advanced Curriculum:</h4>
                <ul>
                  <li>Advanced Diagnostic Procedures</li>
                  <li>Vestibular Assessment</li>
                  <li>Pediatric Audiology</li>
                  <li>Hearing Rehabilitation</li>
                  <li>Clinical Practicum (300 hours)</li>
                </ul>
                <div className="program-details">
                  <p><strong>Entry Requirements:</strong> Certificate in Audiology or equivalent</p>
                  <p><strong>Credits:</strong> 42</p>
                </div>
              </div>
              <button className="program-cta">Program Details</button>
            </div>
          </div>
        </div>
      </section>

      {/* Program Comparison */}
      <section className="program-comparison">
        <div className="container">
          <h2 className="section-title">Program Pathways</h2>
          <div className="comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Certificate</th>
                  <th>Diploma</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Program Focus</td>
                  <td>Basic hearing assessment</td>
                  <td>Comprehensive diagnostics & rehabilitation</td>
                </tr>
                <tr>
                  <td>Clinical Hours</td>
                  <td>50 observation hours</td>
                  <td>300 supervised practice hours</td>
                </tr>
                <tr>
                  <td>Career Outcomes</td>
                  <td>Audiology Assistant</td>
                  <td>Clinical Audiologist (under supervision)</td>
                </tr>
                <tr>
                  <td>Further Education</td>
                  <td>Pathway to Diploma</td>
                  <td>Bachelor's Degree progression</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Learning Experience */}
      <section className="learning-experience">
        <div className="container">
          <h2 className="section-title">Our Learning Facilities</h2>
          <div className="experience-grid">
            <div className="experience-card">
              <FaAssistiveListeningSystems className="exp-icon" />
              <h3>Diagnostic Labs</h3>
              <p>Modern audiometric booths and equipment for comprehensive hearing assessment</p>
            </div>
            <div className="experience-card">
              <FaUserMd className="exp-icon" />
              <h3>Clinical Training</h3>
              <p>Supervised practice in our on-campus teaching clinic</p>
            </div>
            <div className="experience-card">
              <FaClinicMedical className="exp-icon" />
              <h3>Community Outreach</h3>
              <p>Real-world experience through mobile hearing screening programs</p>
            </div>
          </div>
        </div>
      </section>

      {/* Career Support */}
      <section className="career-support">
        <div className="container">
          <h2 className="section-title">Career Outcomes</h2>
          <div className="career-stats">
            <div className="stat-card">
              <div className="stat-number">89%</div>
              <div className="stat-label">Diploma Employment Rate</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">22%</div>
              <div className="stat-label">Industry Growth Projection</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">78%</div>
              <div className="stat-label">Certificate Employment Rate</div>
            </div>
          </div>
          <div className="career-grid">
            <div className="career-path">
              <h3>Certificate Graduates</h3>
              <ul>
                <li>Audiology Assistant</li>
                <li>Hearing Aid Technician</li>
                <li>Community Hearing Screener</li>
              </ul>
            </div>
            <div className="career-path">
              <h3>Diploma Graduates</h3>
              <ul>
                <li>Clinical Audiologist (under supervision)</li>
                <li>Hearing Rehabilitation Specialist</li>
                <li>Educational Audiologist</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="audiology-cta">
        <div className="container">
          <h2>Start Your Audiology Career Today</h2>
          <p>Next intake begins January 2025 - Limited seats available</p>
          <div className="cta-buttons">
            <Link to="/apply" className="primary-cta">Apply Now</Link> 
        
          </div>
        </div>
      </section>
    </div>
  );
}

export default AudiologyCourse;